/// <amd-module name="Reporting/Visuals/VisualSubtitle" />
import * as React from "react";

export interface VisualSubtitleProps {
    text: string;

    /** Optional parameter to hide subtitle  */
    hideSubTitle?: boolean;
}

/** User facing text for supporting blurb providing context about the visual. */
export class VisualSubtitle extends React.PureComponent<VisualSubtitleProps> {
    public render(): JSX.Element {
        return <div className="visual-subtitle text-ellipsis">{!this.props.hideSubTitle && this.props.text}</div>;
    }
}
